import React from 'react';
import ClassAssembly  from 'views/ClassAssembly';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;